(() => {
  'use strict';
  const init = (root) => {
    if (root.dataset.bmReady) return;
    root.dataset.bmReady = 'true';
    const find = (selector) => root.querySelector(selector);
    const all = (selector) => [...root.querySelectorAll(selector)];
    const form = find('[data-bm-form]');
    const radios = all('[data-bm-variant]');
    const addButton = find('[data-bm-add]');
    const stickyButton = find('[data-bm-sticky-add]');
    const error = find('[data-bm-error]');
    const dialog = find('[data-bm-gift-dialog]');
    const giftAddButton = find('[data-bm-gift-add]');
    const giftError = find('[data-bm-gift-error]');
    const codeButton = find('[data-bm-use-code]');
    const codeError = find('[data-bm-code-error]');
    const sticky = find('[data-bm-sticky]');
    const updateSticky = () => sticky.classList.toggle('is-visible', addButton.getBoundingClientRect().bottom < 0 && !dialog.open);
    let activeTrigger = null;
    let giftQuantity = null;
    let busy = false;
    let discountIntent = false;
    let checkoutIntent = false;
    let restoredOverflow = '';
    const selected = () => radios.find((radio) => radio.checked);
    const currency = root.dataset.currency || 'USD';
    const money = (cents) => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency}).format(cents / 100); }
      catch (_) { return '$' + (cents / 100).toFixed(2); }
    };
    const storeIntent = (value) => {
      try {
        if (value) sessionStorage.setItem('bmDiscountIntent', 'BASS10');
        else sessionStorage.removeItem('bmDiscountIntent');
      } catch (_) { /* The explicit cart query also carries the customer's choice. */ }
    };
    const setError = (message, linkToCart = false) => {
      [error, giftError, codeError].forEach((target) => {
        target.textContent = message;
        if (linkToCart) {
          const link = document.createElement('a');
          link.href = root.dataset.cartUrl || '/cart';
          link.textContent = ' Check your cart.';
          target.appendChild(link);
        }
        target.hidden = !message;
      });
    };
    const setBusy = (value) => {
      busy = value;
      const available = selected() && !selected().disabled;
      addButton.disabled = value || !available;
      stickyButton.disabled = value || !available;
      const giftAvailable = radios.some((radio) => radio.dataset.quantity === giftQuantity && !radio.disabled);
      giftAddButton.disabled = value || !giftAvailable;
      codeButton.disabled = value || !radios.some((radio) => radio.dataset.quantity === '5' && !radio.disabled);
      find('[data-bm-code-add-label]').textContent = value ? 'Adding your pack...' : codeButton.disabled ? 'Sold out' : 'Add to cart';
      find('[data-bm-gift-add-label]').textContent = value ? 'Adding your pack...' : giftAvailable ? 'Add to cart' : 'Not available right now';
      all('[data-bm-open-gift]').forEach((button) => { button.disabled = value; });
      dialog.setAttribute('aria-busy', value ? 'true' : 'false');
      form.setAttribute('aria-busy', value ? 'true' : 'false');
      find('[data-bm-add-label]').textContent = value ? 'Adding your pack...' : available ? 'Add to cart' : 'Not available right now';
    };
    const updatePack = () => {
      const radio = selected();
      const qty = Number(radio?.dataset.quantity || 0);
      all('[data-bm-pack]').forEach((pack) => pack.classList.toggle('is-selected', pack.querySelector('input').checked));
      const mysteryBump = find('[data-bm-mystery-bump]');
      if (mysteryBump) {
        mysteryBump.hidden = qty === 5;
        const input = mysteryBump.querySelector('input');
        input.disabled = qty === 5;
        if (qty === 5) input.checked = false;
      }
      if (qty !== 5) {
        discountIntent = false;
        storeIntent(false);
      }
      find('[data-bm-discount-note]').hidden = !discountIntent;
      let total = Number(radio?.dataset.price || 0);
      all('[data-bm-bump]').filter((input) => input.checked && !input.disabled).forEach((input) => { total += Number(input.dataset.price); });
      const totalLabel = find('[data-bm-total]');
      totalLabel.textContent = radio ? money(total) : '';
      totalLabel.hidden = !radio;
      find('[data-bm-sticky-price]').textContent = radio ? money(total) : '';
      find('[data-bm-sticky-pack]').textContent = qty ? `${qty} ${qty === 1 ? 'mask' : 'masks'}` : 'Not available right now';
      setBusy(busy);
    };
    if (!selected()) {
      const first = radios.find((radio) => radio.dataset.quantity === '3' && !radio.disabled) || radios.find((radio) => !radio.disabled);
      if (first) first.checked = true;
    }
    radios.forEach((radio) => radio.addEventListener('change', () => { setError(''); updatePack(); }));
    all('[data-bm-bump]').forEach((input) => input.addEventListener('change', updatePack));
    const extras = find('[data-bm-extras]');
    extras.hidden = !extras.querySelector('[data-bm-bump]');
    updatePack();

    // Real variant IDs come from Liquid. A failed request never shows a success state.
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy) return;
      const radio = selected();
      if (!radio || radio.disabled || !/^\d+$/.test(radio.value)) {
        setError('This pack is not available right now. Please pick another pack.');
        return;
      }
      setError('');
      setBusy(true);
      const qty = Number(radio.dataset.quantity);
      const goToCheckout = checkoutIntent && qty === 5;
      checkoutIntent = false;
      const properties = {'Pack': `${qty} ${qty === 1 ? 'mask' : 'masks'}`};
      if (qty === 3) properties['Included gifts'] = 'Knot guide + lure cheat sheet';
      if (qty === 5) properties['Included gifts'] = 'Knot guide + lure cheat sheet; mystery tackle gift';
      const items = [{id: Number(radio.value), quantity: 1, properties}];
      all('[data-bm-bump]').filter((input) => input.checked && !input.disabled).forEach((input) => {
        if (/^\d+$/.test(input.dataset.variantId)) items.push({id: Number(input.dataset.variantId), quantity: 1});
      });
      let confirmed = false;
      try {
        const route = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
        const response = await fetch(`${route}cart/add.js`, {
          method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          credentials: 'same-origin', body: JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          setError(typeof result.description === 'string' ? result.description : 'We could not add that pack. Please check your choice and try again.');
          return;
        }
        if (!Array.isArray(result.items) || !result.items.some((item) => Number(item.variant_id || item.id) === Number(radio.value))) {
          setError('We could not confirm the pack was added. Please check your cart before trying again.', true);
          return;
        }
        confirmed = true;
        const useCode = discountIntent && qty === 5;
        storeIntent(useCode);
        const destination = new URL(root.dataset.cartUrl || '/cart', window.location.origin);
        if (useCode) destination.searchParams.set('bm_discount', 'BASS10');
        if (goToCheckout) {
          const discountResponse = await fetch(`${route}cart/update.js`, {
            method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            credentials: 'same-origin', body: JSON.stringify({discount: 'BASS10'})
          });
          const discountedCart = await discountResponse.json();
          const applied = discountResponse.ok && (discountedCart.items || []).some((item) =>
            Number(item.variant_id || item.id) === Number(radio.value) &&
            (item.line_level_discount_allocations || []).some((allocation) => String(allocation.discount_application?.title).toUpperCase() === 'BASS10')
          );
          if (applied) {
            storeIntent(false);
            window.location.assign(new URL(`${route}checkout`, window.location.origin).href);
            return;
          }
        }
        window.location.assign(destination.href);
      } catch (_) {
        if (confirmed && goToCheckout) {
          const destination = new URL(root.dataset.cartUrl || '/cart', window.location.origin);
          destination.searchParams.set('bm_discount', 'BASS10');
          window.location.assign(destination.href);
          return;
        }
        setError('We could not confirm your cart. Please check it before trying again.', true);
      } finally {
        if (!confirmed) setBusy(false);
      }
    });

    const thumbnails = all('[data-bm-thumb]');
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        const image = find('[data-bm-main-image]');
        image.src = thumb.dataset.imageSrc;
        image.alt = thumb.dataset.imageAlt;
        image.classList.toggle('is-product-shot', /bm-0[1-6]-/.test(thumb.dataset.imageSrc));
        thumbnails.forEach((item) => { item.classList.remove('is-active'); item.removeAttribute('aria-current'); });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
        find('[data-bm-image-count]').textContent = `${String(index + 1).padStart(2, '0')} / ${String(thumbnails.length).padStart(2, '0')}`;
        find('.bmp__photo-label').hidden = index !== 0;
      });
    });

    // A native dialog keeps hidden controls out of focus order and supports Escape.
    let scratchRevealed = false;
    let scratchContext = null;
    let scratchPoints = new Set();
    let pointerDown = false;
    let lastPoint = null;
    const canvas = find('[data-bm-scratch-canvas]');
    const revealScratch = () => {
      if (scratchRevealed) return;
      scratchRevealed = true;
      pointerDown = false;
      canvas.hidden = true;
      find('[data-bm-reveal-scratch]').hidden = true;
      find('[data-bm-scratch-stage]').hidden = true;
      find('[data-bm-five-gift]').hidden = true;
      find('[data-bm-three-gift]').hidden = false;
      giftAddButton.hidden = giftQuantity === '5';
      find('[data-bm-show-second]').hidden = giftQuantity !== '5';
      find('[data-bm-gift-title]').textContent = 'Your free gift.';
      dialog.scrollTop = 0;
      (giftQuantity === '5' ? find('[data-bm-show-second]') : giftAddButton).focus();
    };
    const paintScratch = () => {
      scratchRevealed = false;
      scratchPoints = new Set();
      pointerDown = false;
      lastPoint = null;
      canvas.hidden = false;
      const rect = canvas.getBoundingClientRect();
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(rect.width * ratio);
      canvas.height = Math.round(rect.height * ratio);
      scratchContext = canvas.getContext('2d', {willReadFrequently: true});
      if (!scratchContext || !rect.width || !rect.height) return;
      const ctx = scratchContext;
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      const gradient = ctx.createLinearGradient(0, 0, rect.width, rect.height);
      gradient.addColorStop(0, '#acb69e');
      gradient.addColorStop(.48, '#dbe1d2');
      gradient.addColorStop(1, '#9baa8b');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, rect.width, rect.height);
      ctx.strokeStyle = 'rgba(90,107,71,.12)';
      ctx.lineWidth = 1;
      for (let x = -rect.height; x < rect.width; x += 14) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x + rect.height, rect.height); ctx.stroke(); }
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#405133';
      ctx.font = 'bold 42px Arial';
      ctx.fillText('?', rect.width / 2, rect.height / 2 - 22);
      ctx.font = 'bold 13px Arial';
      ctx.fillText('SCRATCH FOR YOUR GIFT', rect.width / 2, rect.height / 2 + 24);
      ctx.font = '10px Arial';
      ctx.fillText('a little extra for your next trip', rect.width / 2, rect.height / 2 + 47);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.strokeStyle = '#000';
      ctx.fillStyle = '#000';
      ctx.lineWidth = 44;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
    };
    const scratchAt = (event) => {
      if (!pointerDown || !scratchContext || scratchRevealed) return;
      const rect = canvas.getBoundingClientRect();
      const point = {x: event.clientX - rect.left, y: event.clientY - rect.top};
      const ctx = scratchContext;
      ctx.beginPath();
      if (lastPoint) { ctx.moveTo(lastPoint.x, lastPoint.y); ctx.lineTo(point.x, point.y); ctx.stroke(); }
      else { ctx.arc(point.x, point.y, 22, 0, Math.PI * 2); ctx.fill(); }
      lastPoint = point;
      scratchPoints.add(`${Math.round(point.x / 12)},${Math.round(point.y / 12)}`);
      // Sample actual cleared pixels, so long pointer strokes count correctly.
      if (scratchPoints.size < 2) return;
      const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let cleared = 0;
      let sampled = 0;
      for (let i = 3; i < pixels.length; i += 64) { sampled += 1; if (pixels[i] < 128) cleared += 1; }
      if (sampled && cleared / sampled >= .25) revealScratch();
    };
    canvas.addEventListener('pointerdown', (event) => {
      if (event.button !== 0 && event.pointerType === 'mouse') return;
      pointerDown = true;
      lastPoint = null;
      canvas.setPointerCapture(event.pointerId);
      scratchAt(event);
    });
    canvas.addEventListener('pointermove', scratchAt);
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((name) => canvas.addEventListener(name, () => { pointerDown = false; lastPoint = null; }));
    find('[data-bm-reveal-scratch]').addEventListener('click', revealScratch);

    const closeGift = () => {
      if (dialog.open) {
        document.documentElement.style.overflow = restoredOverflow;
        dialog.close();
      }
    };
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeGift(); });
    const resetGift = (mode) => {
      find('[data-bm-three-gift]').hidden = true;
      find('[data-bm-five-gift]').hidden = false;
      ['[data-bm-first-gift]', '[data-bm-second-gift]', '[data-bm-code-gift]'].forEach((selector) => { find(selector).hidden = true; });
      find('[data-bm-scratch-stage]').hidden = false;
      find('[data-bm-reveal-scratch]').hidden = false;
      find('[data-bm-show-second]').hidden = true;
      find('[data-bm-gift-title]').textContent = 'Scratch for your gift.';
      find('[data-bm-gift-description]').textContent = mode === '5'
        ? 'A short knot guide and lure cheat sheet. Free with your 5-mask pack.'
        : 'A short knot guide and lure cheat sheet. Free with your 3-mask pack.';
      const price = Number(radios.find((radio) => radio.dataset.quantity === '5')?.dataset.price || 6099);
      find('[data-bm-discount-price]').textContent = `${money(price - Math.floor(price / 10))} with BASS10.`;
      setBusy(busy);
    };
    all('[data-bm-open-gift]').forEach((button) => {
      if (typeof dialog.showModal !== 'function') return;
      button.hidden = false;
      button.addEventListener('click', () => {
        const mode = button.dataset.bmOpenGift;
        giftQuantity = mode;
        activeTrigger = button;
        setError('');
        const tier = radios.find((radio) => radio.dataset.quantity === mode && !radio.disabled);
        if (tier) { tier.checked = true; updatePack(); }
        resetGift(mode);
        restoredOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.hidden = false;
        dialog.showModal();
        sticky.classList.remove('is-visible');
        dialog.scrollTop = 0;
        find('[data-bm-close-gift]').focus();
        requestAnimationFrame(() => { if (dialog.open) paintScratch(); });
      });
    });
    giftAddButton.addEventListener('click', () => {
      if (busy) return;
      const tier = radios.find((radio) => radio.dataset.quantity === giftQuantity && !radio.disabled);
      if (!tier) {
        setError('This pack is not available right now. Please pick another pack.');
        return;
      }
      tier.checked = true;
      updatePack();
      form.requestSubmit(addButton);
    });
    all('[data-bm-close-gift]').forEach((button) => button.addEventListener('click', closeGift));
    dialog.addEventListener('close', () => {
      dialog.hidden = true;
      document.documentElement.style.overflow = restoredOverflow;
      if (activeTrigger?.isConnected) activeTrigger.focus();
      updateSticky();
    });
    dialog.addEventListener('click', (event) => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) closeGift();
    });
    find('[data-bm-show-second]').addEventListener('click', () => {
      find('[data-bm-three-gift]').hidden = true;
      find('[data-bm-five-gift]').hidden = false;
      find('[data-bm-scratch-stage]').hidden = true;
      find('[data-bm-first-gift]').hidden = true;
      find('[data-bm-second-gift]').hidden = false;
      find('[data-bm-gift-title]').textContent = 'Your next free gift.';
      dialog.scrollTop = 0;
      find('[data-bm-show-code]').focus();
    });
    find('[data-bm-show-code]').addEventListener('click', () => {
      find('[data-bm-second-gift]').hidden = true;
      find('[data-bm-code-gift]').hidden = false;
      find('[data-bm-gift-title]').textContent = 'One more surprise.';
      dialog.scrollTop = 0;
      find('[data-bm-use-code]').focus();
    });
    codeButton.addEventListener('click', () => {
      if (busy) return;
      const five = radios.find((radio) => radio.dataset.quantity === '5' && !radio.disabled);
      if (!five) { setError('The 5-pack is sold out. Please pick another pack.'); return; }
      five.checked = true;
      discountIntent = true;
      checkoutIntent = false;
      storeIntent(true);
      updatePack();
      form.requestSubmit(addButton);
    });
    if ('IntersectionObserver' in window) {
      sticky.hidden = false;
      const observer = new IntersectionObserver(updateSticky, {threshold: 0});
      observer.observe(addButton);
      root.bmCleanup = () => { observer.disconnect(); if (dialog.open) closeGift(); };
    }
  };
  const initAll = (scope = document) => {
    if (scope.matches?.('[data-bm-product]')) init(scope);
    scope.querySelectorAll('[data-bm-product]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-bm-product]').forEach((root) => root.bmCleanup?.()));
})();
